var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from './axios';
export function getStatiMatrimoniali() {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("api/statimatrimoniali")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
export function getcareProviders() {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios.get("api/careProviders")];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
export function getLivelliConfidenzionalita() {
    var stateList = [
        {
            value: 1,
            label: 'Nessuna Restrizione'
        },
        {
            value: 2,
            label: 'Basso'
        },
        {
            value: 3,
            label: 'Moderato'
        }
    ];
    return stateList;
}
export function getStatiDiagnosi() {
    var stateList = [
        {
            value: 1,
            label: 'Sospetta'
        },
        {
            value: 0,
            label: 'Confermata'
        },
        {
            value: 2,
            label: 'Esclusa'
        }
    ];
    return stateList;
}
export function getStatiIndagini() {
    var stateList = [
        {
            value: 1,
            label: 'Programmata'
        },
        {
            value: 0,
            label: 'Richiesta'
        },
        {
            value: 2,
            label: 'Completa'
        },
    ];
    return stateList;
}
export function getLiveliVisibilita() {
    var liveliVisibilita = [
        {
            value: 1,
            label: 'Totale'
        },
        {
            value: 3,
            label: 'Parziale'
        },
        {
            value: 2,
            label: 'Minima'
        },
    ];
    return liveliVisibilita;
}
export function getDonorStatus() {
    var approvalStatus = [
        {
            label: "Non acconsento",
            value: "0"
        },
        {
            label: "Acconsento",
            value: "1"
        }
    ];
    return approvalStatus;
}
export function getBloodType() {
    var bloodGroupList = [
        {
            label: '0+ (Gruppo Zero, Rh Positivo)',
            value: '0 +',
        },
        {
            label: '0- (Gruppo Zero, Rh Negativo)',
            value: '0 -',
        },
        {
            label: 'A+ (Gruppo A, Rh Positivo)',
            value: 'A +',
        },
        {
            label: 'A- (Gruppo A, Rh Negativo)',
            value: 'A -',
        },
        {
            label: 'B+ (Gruppo B, Rh Positivo)',
            value: 'B +',
        },
        {
            label: 'B- (Gruppo B, Rh Negativo)',
            value: 'B -',
        },
        {
            label: 'AB+ (Gruppo AB, Rh Positivo)',
            value: 'AB +',
        },
        {
            label: 'AB- (Gruppo AB, Rh Negativo)',
            value: 'AB -',
        }
    ];
    return bloodGroupList;
}
